//------------------------------------------------------------------------------
export interface IOWWindowsListenerDelegate {
  onHotKeyChanged(info: any);
}

//------------------------------------------------------------------------------
export class OWHotkeysListener {
  private _delegate: IOWWindowsListenerDelegate;

  //----------------------------------------------------------------------------
  constructor(delegate: IOWWindowsListenerDelegate) {
    this._delegate = delegate;
  }

  //----------------------------------------------------------------------------
  public start(): void {    
    // Remove, potential previous listeners
    overwolf.settings.OnHotKeyChanged.removeListener(this.onHotKeyChanged);
    overwolf.settings.OnHotKeyChanged.addListener(this.onHotKeyChanged);
  }

  //----------------------------------------------------------------------------
  public stop(): void {
    overwolf.windows.onStateChanged.removeListener(this.onHotKeyChanged);
  }

  //----------------------------------------------------------------------------
  private onHotKeyChanged =
    (hotkeyInfo: any): void => {
    if (!hotkeyInfo) {
      return;
    }
  }
}
